/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React, { useEffect, useState } from "react";
import { t as tt } from '../utils/i18n';
var ContextualConsentNotice = function ContextualConsentNotice(_ref) {
  var manager = _ref.manager,
    style = _ref.style,
    config = _ref.config,
    t = _ref.t,
    lang = _ref.lang,
    service = _ref.service;
  function asTitle(str) {
    return str.split('-').map(function (s) {
      return s.slice(0, 1).toUpperCase() + s.slice(1);
    }).join(' ');
  }
  var decline = function decline() {};

  /**
   * Bouton "accepter" du contextual consent
   */
  var accept = function accept() {
    manager.saveConsents();
    manager.applyConsentsOnce(service.name, true, true);
  };
  var additionalClass = config.additionalClass,
    embedded = config.embedded,
    stylePrefix = config.stylePrefix;
  var title = tt(service.translations || {}, lang, 'zz', ['!', 'title']) || t(['!', service.name, 'title?']) || asTitle(service.name);
  return /*#__PURE__*/React.createElement("div", {
    lang: lang,
    className: (stylePrefix || 'orejime') + (additionalClass !== undefined ? ' ' + additionalClass : '') + ' cm-as-context-notice'
  }, /*#__PURE__*/React.createElement("div", {
    className: "context-notice" + (style !== undefined ? " cm-".concat(style) : "")
  }, /*#__PURE__*/React.createElement("p", null, t(['contextualConsent', 'description'], {
    title: title
  })), /*#__PURE__*/React.createElement("p", {
    className: "cm-buttons"
  }, /*#__PURE__*/React.createElement("button", {
    className: "cm-btn cm-btn-success-var",
    type: "button",
    onClick: accept
  }, t(['contextualConsent', 'acceptAlways'])))));
};
export default ContextualConsentNotice;